import React, { useState, useEffect, useContext } from "react";
import styles from "./style.module.scss";

import { MainContext } from "../context/MainContext";
import { setService } from "../helpers/setService";

import ListItemByID from "../components/ListItemByID/ListItemByID";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function List() {
  const { markers, serviceByDate, setServiceByDate, action } = useContext(MainContext);
  const [array, setArray] = useState([]);

  useEffect(() => {
    const res = setService(markers);
    setServiceByDate(res.reverse());
  }, [markers, setServiceByDate]);

  useEffect(() => {
    const arr = []
    action.forEach((item) => {
      if (item.type === "comment") {
        arr.push(item.actions)
      }
    });
    setArray(arr[0]);
  }, [action]);

  return (
    <>
      <div className={styles.list_page}>
        <h1 className={styles.list_page_title}>Отчеты и комментарии</h1>
      </div>
      <div className={styles.list}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel01-content`}
            id={`panel0001-header`}
          >
            <Typography component="span">Отчеты</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {serviceByDate.map((item, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <Typography component="span">{item.date}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {item.ids.map((name, index) => (
                    <Typography key={index} component="div">
                      <ListItemByID listID={name} />
                    </Typography>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel0002-content`}
            id={`panel02-header`}
          >
            <Typography component="span">Комментарии</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {array.map((name, index) => (
              <Typography key={index} component="div">
                <ListItemByID listID={name.id} comment={name.comment} />
              </Typography>
            ))}
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
}

export default List;
